module.exports = new __parcel__URL__("Warehouse.2c821fe3.jpg").toString();